<template>
  <div class="container">
    <div class="inquery-container">
      <history-item-heading
        :label="$t('compliance_reviews.submissionForComplianceReviews.inquery')"
        :date="historyItem.createdUtc"
        :user="historyItem.submittedByUserEmail"
      />
      <div class="comment-container">
        {{ historyItem.submissionComment }}
      </div>
    </div>
    <history-item-heading
      :label="$t('compliance_reviews.submissionForComplianceReviews.answer')"
      :date="historyItem.completedUtc"
      :user="historyItem.resolvedByUserEmail"
    />
    <div class="comment-container">
      {{ historyItem.resolutionComment }}
    </div>
    <div v-if="resolution" class="resolution-container">
      <span class="resolution-label">
        {{ $t("compliance_reviews.submissionForComplianceReviews.setStatus") }}
      </span>
      <span :class="resolutionStatusClass">
        {{ resolution }}
      </span>
    </div>
  </div>
</template>

<script>
import { RESOLUTION_STATUS } from "@/constants/complianceReview";
import HistoryItemHeading from "./HistoryItemHeading.vue";

export default {
  props: {
    historyItem: { type: Object, default: null }
  },

  components: {
    HistoryItemHeading
  },

  computed: {
    resolutionStatusClass() {
      return this.historyItem.resolution === RESOLUTION_STATUS.CONSULTED
        ? "success"
        : "danger";
    },

    resolution() {
      return this.historyItem?.resolution
        ? this.$t(
            `compliance_reviews.resolutionStatus.${this.historyItem.resolution}`
          )
        : null;
    }
  }
};
</script>

<style scoped>
.container {
  padding: 1rem;
  margin-bottom: 1rem;
  background: var(--compliance-review-history-item-color);
  border-radius: 0.5rem;
}

.inquery-container {
  margin-bottom: 2.5rem;
}

.comment-container {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.resolution-container {
  display: flex;
  justify-content: space-between;
}

.resolution-label {
  font-size: 1rem;
  font-weight: bold;
}

.danger {
  color: var(--text-danger);
}

.success {
  color: var(--text-success);
}
</style>
